export default __webpack_public_path__ + "static/media/price-lookup.2ae31892.svg";